import React from "react";
import BatchAddressImport from "@/components/batch-address-import";

export default function BatchImportPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex flex-col flex-grow min-h-screen">
        <div className="flex-grow pt-2 pb-2 px-0 sm:px-2 lg:px-4 w-full">
          <div className="space-y-4">
            <div className="mt-3">
              <BatchAddressImport
                onAddressesProcessed={(result) => {
                  console.log("Batch processing complete", result);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 